// @flow

type State = { [string]: mixed };

type Options = {
  stale?: boolean,
  compress?: boolean
};

function encoder(compress: boolean = false) {
  return compress
    ? require('lz-string').compressToBase64 // compressToUTF16
    : require('kodyl-js/shared/base64').encode;
}

function decoder(compress: boolean = false) {
  return compress
    ? require('lz-string').decompressFromBase64 // decompressFromUTF16
    : require('kodyl-js/shared/base64').decode;
}

const DEFAULT_STATE = {};

function serializeStores(state: State) {
  return Object.keys(state).reduce((acc, name) => {
    const store = state[name];
    try {
      const { serialize } = require(`./modules/${name}`);
      acc[name] = typeof serialize === 'function' ? serialize(store) : store;
    } catch (err) {
      acc[name] = store;
    }
    return acc;
  }, {});
}

export function serialize(
  state: State = DEFAULT_STATE,
  { compress = false }: Options = {}
) {
  const str = JSON.stringify(serializeStores(state));

  return encoder(compress)(str);
}

function deserializeStores(state: State, stale: boolean) {
  return Object.keys(state).reduce((acc, name) => {
    const store = state[name];
    try {
      const { deserialize } = require(`./modules/${name}`);
      acc[name] =
        typeof deserialize === 'function' ? deserialize(store, stale) : store;
    } catch (err) {
      if (__DEV__) {
        console.error(err);
      }
      acc[name] = store;
    }
    return acc;
  }, {});
}

export function deserialize(
  state: string,
  { compress = false, stale = false }: Options = {}
) {
  if (!state) {
    return DEFAULT_STATE;
  }

  try {
    const obj = JSON.parse(__SERVER__ ? state : decoder(compress)(state));
    return deserializeStores(obj, stale);
  } catch (err) {
    if (__DEV__) {
      console.error(err);
    }
    // TODO: Report client-side error
    return DEFAULT_STATE;
  }
}
